// Placeholders to prevent errors in deployed web app
export const localEnvironment = {};
export const stagingEnvironment = {};
export const productionEnvironment = {};
